export type RecentlyViewedItem = {
  id: string;
  title: string;
  address: string;
  rent: number;
  image?: string;
  viewedAt: number;
};

const STORAGE_KEY = "recentlyViewed";
const MAX_ITEMS = 6;

export function getRecentlyViewed(): RecentlyViewedItem[] {
  if (typeof window === "undefined") return [];
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    const data = raw ? (JSON.parse(raw) as RecentlyViewedItem[]) : [];
    // Sort by most recent
    return data
      .filter((x) => x && x.id)
      .sort((a, b) => (b.viewedAt || 0) - (a.viewedAt || 0))
      .slice(0, MAX_ITEMS);
  } catch {
    return [];
  }
}

export function addRecentlyViewed(item: Omit<RecentlyViewedItem, "viewedAt">) {
  if (typeof window === "undefined") return;
  try {
    const existing = getRecentlyViewed();
    const updated: RecentlyViewedItem[] = [
      { ...item, viewedAt: Date.now() },
      ...existing.filter((x) => x.id !== item.id),
    ].slice(0, MAX_ITEMS);
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
  } catch {
    // ignore storage errors
  }
}
